import React from 'react'
import HouseHold from '../../../views/Insurance/HouseHold/HouseHolds'

const HouseholdInsurance = () => {
  return (
    <HouseHold/>
  )
}

export default HouseholdInsurance